import { noForwardProps } from '@apeiron/temp'
import { Box, Button, styled, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

const Container = styled(Box)`
  background-color: #0e0e0e;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 35px 30px;
  width: 100%;
`

const Header = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
`

const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  line-height: 20px;
`

const Description = styled(Typography)`
  color: #838383;
  overflow-wrap: break-word;
`

const NewButton = styled(Button, noForwardProps)<NewButtonProps>`
  ${props =>
    props.__variant === 'public'
      ? 'background: linear-gradient(90deg, #32b2fa 0%, #347cc0 50%, #353875 100%);'
      : 'background: linear-gradient(32deg, #57b04f 0%, #2b7833 100%);'}
  border-radius: 4px;
  color: white;
  font-size: 18px;
  font-weight: 400;
  margin-top: 5px;
  max-width: 265px;
  text-transform: none;
  width: 80%;
  :disabled {
    color: white;
    filter: brightness(0.45) contrast(0.83) grayscale(100%);
  }
`

const RentalNew: FC<Props> = ({
  onNewClick,
  title,
  description,
  buttonText,
  subTitle,
  dialog,
  variant
}) => {
  return (
    <Container>
      <Header>
        <Title>{title}</Title>
        {subTitle}
      </Header>
      <Description>{description}</Description>
      <NewButton __variant={variant} onClick={onNewClick}>
        {buttonText}
      </NewButton>
      {dialog}
    </Container>
  )
}

type Props = {
  onNewClick: () => void
  title: string
  description: string
  buttonText: string
  subTitle?: ReactNode
  dialog: ReactNode
  variant: 'public' | 'invite'
}

type NewButtonProps = {
  __variant: 'public' | 'invite'
}

export default RentalNew
